import createApi from 'api/createApi';

export const tags = {
	kbTemplate__sourceIncome: 'mw/kb/source-income',
	kbTemplate__specialConditions: 'mw/kb/special-conditions',
	kbTemplate__destinationTree: 'mw/kb/destination-tree',
	kbTemplate__locationSearch: 'mw/kb/location-search',
};

export const knowledgeBaseTemplateApi = createApi({
	reducerPath: 'mw/knowledgeBaseTemplateApi',

	endpoints: (builder) => ({
		sourceIncomeList: builder.query({
			query: () => ({
				method: 'GET',
				url: '/mw/kb/source-income',
			}),
			providesTags: [tags.kbTemplate__sourceIncome],
		}),
		specialConditionsList: builder.query({
			query: () => ({
				method: 'GET',
				url: '/mw/kb/special-conditions',
			}),
			providesTags: [tags.kbTemplate__specialConditions],
		}),
		destinationTree: builder.query({
			query: () => ({
				method: 'GET',
				url: '/mw/kb/destination-tree',
			}),
			providesTags: [tags.kbTemplate__destinationTree],
		}),
		locationSearch: builder.mutation({
			query: ({ query }) => ({
				method: 'GET',
				url: query
					? `/mw/kb/location-search?query=${encodeURIComponent(query)}`
					: '/mw/kb/location-search',
			}),
			providesTags: [tags.kbTemplate__locationSearch],
		}),
	}),
});

export const {
	sourceIncomeList,
	specialConditionsList,
	destinationTree,
	locationSearch,
} = knowledgeBaseTemplateApi.endpoints;

export default knowledgeBaseTemplateApi;
